// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { RtwStateType } from "./types";

export const initialState: RtwStateType = {
  requestsInProgress: 0,
  schema: null,
  list: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },
  liveProcessesFilter: null,

  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    showAddRtwAttachmentModal: false,
  },
  addFileInProgress: false,
};

export default initialState;
